import React, {useCallback, useMemo, useState} from 'react'
import styled from 'styled-components'
import {VideoHLSPlayer} from 'common/components'
import {GiftShopProfileResendVideoItemProps} from './GiftShopProfileResendVideoProps'
import GiftShopProfileResendVideoItemBase from './GiftShopProfileResendVideoItemBase'

const StyledHLS = styled(VideoHLSPlayer)`
  object-fit: contain;
  width: 100%;
  aspect-ratio: 1;
`

const GiftShopProfileResendVideoItemStandard = ({
  videoRef,
  date,
  src = '',
  title,
  duration,
  size,
}: GiftShopProfileResendVideoItemProps) => {
  const statePaused = useState(true)
  const setPaused = statePaused[1]

  const handlePause = useCallback(() => {
    setPaused(true)
    videoRef.current?.pause()
  }, [setPaused, videoRef])

  const handlePlay = useCallback(() => {
    setPaused(false)
    videoRef.current?.play()
  }, [setPaused, videoRef])

  const handleRenderHLSPlayer = useMemo(
    () => (
      <StyledHLS
        playerRef={videoRef}
        src={src}
        onEnded={() => setPaused(true)}
      />
    ),
    [setPaused, src, videoRef],
  )

  return (
    <GiftShopProfileResendVideoItemBase
      statePaused={statePaused}
      videoElement={handleRenderHLSPlayer}
      date={date}
      duration={duration}
      size={size}
      title={title}
      onPause={handlePause}
      onPlay={handlePlay}
      hasSource
    />
  )
}

export default GiftShopProfileResendVideoItemStandard
